import React from "react";
import { Selector, Text, FrameIcon } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { LogoutWrapper, LogoutSubtextStyled, HeaderTextStyled } from "../styles/Styled";

export const Logout = ({ confirmationOptions, onItemSelected, isFromSettingsPage }) => {
  return (
    <LogoutWrapper>
      <FrameIcon name="logout" alignSelf="start" />
      <HeaderTextStyled rank="1" text={i18n.get("pages.settings.logout.title")} size="large" />
      <LogoutSubtextStyled text={i18n.get("pages.settings.logout.device")} type="greyLight" size="small" />
      <Selector
        items={confirmationOptions}
        onItemSelected={onItemSelected}
        isFromSettingsPage={isFromSettingsPage}
        size={isFromSettingsPage ? "xmedium" : "default"}
        textAlign="center"
      />
    </LogoutWrapper>
  );
};
